"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCUMENT_UPLOAD = exports.DOCUMENT_UPLOAD_DATA_FRAGMENT = exports.ALL_ATTACHED_GARAGE_CRAWLSPACE_INFO = void 0;
const client_1 = require("@apollo/client");
exports.ALL_ATTACHED_GARAGE_CRAWLSPACE_INFO = (0, client_1.gql) `
  fragment AllAttachedGarageCrawlspaceInfo on AttachedGarageCrawlspaceInfo {
    sqft
    netAreaOfFloodOpenings
    numFloodOpenings
    engineeredFloodOpenings
    oneFloodOpeningTwoSides
    numNonEngineeredOpenings
    numEngineeredOpenings
    netAreaNonEngineeredOpenings
    ratedAreaOfEngineeredOpenings
  }
`;
exports.DOCUMENT_UPLOAD_DATA_FRAGMENT = (0, client_1.gql) `
  fragment DocumentUploadDataFragment on DocumentUpload {
    id
    originalFilename
    name
    formData
    formStructure @skip(if: $isPublic)
    createdAt
    isDeletable @skip(if: $isPublic)
    hasAssociatedAIActionRun
    externalDocumentURL
    accountDocumentType {
      id
      name
      color
      allowedMimeTypes
      attachments {
        type
        customMapIds
      }
      order
      isSensitive
      documentType {
        id
        name
      }
    }
    issuedAt
    hiddenFromPublic
    mimeType

    submission @skip(if: $isPublic) {
      id
      formData
      tags {
        text
        display: tagDisplay
        uiSchemaPath
      }
      submissionTypeVersion {
        id
        submissionType {
          id
          name
          description
        }
      }
    }
  }
`;
exports.DOCUMENT_UPLOAD = (0, client_1.gql) `
  query getDocumentUpload($id: ID!, $isPublic: Boolean!) {
    documentUpload(id: $id) {
      ...DocumentUploadDataFragment

      capturedAt
      capturedLocation
      objectType
      objectId
      property {
        id
        streetAddress
        city
        state
        zipcode
        fullAddress
        latitude
        longitude
        hiddenFromPublic
        parcel {
          parcelId
          block
          lot
        }
      }

      customMapGeometry {
        id
        customMapId
        customMap {
          id
          hiddenFromPublic
        }
      }

      elevationCertificate {
        id
        buildingOwnerName
        errorDetectionEligibility {
          status
          heading
          note
        }
        type
        propertyDescription
        buildingUse
        latitude
        longitude
        horizontalDatum
        buildingDiagramNumber
        firmIndexDate
        firmPanelEffectiveDate
        floodZone
        baseFloodElevation
        baseFloodElevationDatum
        baseFloodElevationDatumOther
        baseFloodElevationSource
        fiveHundredYearFloodElevation {
          value
          units
        }
        isBuildingLocatedInCbrsOrOpa
        buildingLocatedInCbrsOrOpaDesignationDate
        buildingLocatedInCbrsOrOpa
        buildingLocatedSeawardOfLimwa
        benchmarkUtilized
        elevationDatum
        elevationDatumOther
        verticalDatum
        elevationDatumComments
        buildingElevationSource
        buildingElevationInfo {
          topOfBottomFloor {
            value
            units
          }
          topOfNextHigherFloor {
            value
            units
          }
          bottomOfLowestHorizontalStructuralMember {
            value
            units
          }
          attachedGarage {
            value
            units
          }
          lowestElevationOfMachineryOrEquipment {
            value
            units
          }
          lowestAdjacentGrade {
            value
            units
            type
          }
          highestAdjacentGrade {
            value
            units
            type
          }
          lowestAdjacentGradeAtLowestElevationOfDeckOrStairs {
            value
            units
          }
        }
        issuedAt
        comments
        coordinatesProvidedBySurveyor
        conversionFactorUsed
        streetAddress
        nfipCommunityName
        nfipCommunityNumber
        nfipCountyName
        nfipState
        state
        city
        zipcode
        certifierName
        certifierLicenseNumber
        certifierInfo {
          name
          licenseNumber
          email
          telephone
          sealPresent
          signaturePresent
        }
        propertyOwnerInfo {
          name
          signaturePresent
          date
        }
        firmMapNumber
        firmSuffix
        extractedData
        finishedConstruction
        formYear
        attachedGarageInfo {
          ...AllAttachedGarageCrawlspaceInfo
        }
        crawlspaceInfo {
          ...AllAttachedGarageCrawlspaceInfo
        }
        buildingMeasurementInfo {
          measurementsBasedOn
          topOfBottomFloorElevatedPerOrdinance
          offsets {
            topOfBottomFloorAboveOrBelowHag {
              value
              units
              aboveOrBelow
            }
            topOfBottomFloorAboveOrBelowLag {
              value
              units
              aboveOrBelow
            }
            nextHigherFloorAboveOrBelowHag {
              value
              units
              aboveOrBelow
            }
            attachedGarageTopOfSlabAboveOrBelowHag {
              value
              units
              aboveOrBelow
            }
            topOfMachineryPlatformAboveOrBelowHag {
              value
              units
              aboveOrBelow
            }
          }
        }
        communityInfo {
          sectionCTakenFromOtherAuthorizedSource
          sectionECompletedByLocalOfficial
          sectionHCompletedByLocalOfficial
          sectionGCommentsProvidedByLocalOfficial
          communityInfoProvidedForFloodplainManagementPurposes
          permitNumber
          permitDateIssued
          certificateOfComplianceOrOccupancyDateIssued
          permitIssuedForNewConstructionOrSI
          elevations {
            asBuiltLowestFloor {
              value
              units
              datum
            }
            bottomOfAsBuiltLowestHorizontalStructuralMember {
              value
              units
              datum
            }
            bfeOrDepthOfFloodingAtBuildingSite {
              value
              units
              datum
            }
            communityMinimumRequirementOfLowestFloorOrLowestHorizontalStructuralMember {
              value
              units
              datum
            }
          }
          varianceIssued
          localOfficialInfo {
            name
            telephone
            email
            dateSigned
            comments
            signaturePresent
          }
        }
        everyPageHasHeaderAddress
        pageHeaderAddressesAreConsistent
        numberOfPhotosProvided
        everyPhotoIsInColor
        validationErrors {
          data {
            errorCode
            id
            issue
            type
            value
            valueAttr
            field
            note
            ignored
            ignoredReason @skip(if: $isPublic)
          }
          count
        }
        firms {
          id
          name
          floodway
          jurisdictions
          useForRegulation
          datum
          stringStaticBFE
          stringDepth
          isApproximateBfe
          mscLink
          coastalA
          panels {
            panelNumber
          }
          zones {
            floodzone
            floodway
            coastalA
            stringStaticBFE
            stringDepth
            datum
          }
        }
      }

      certificateUpload {
        id
        cancelationReason @skip(if: $isPublic)
        uploadSource @skip(if: $isPublic)
        status
        lowConfidence @skip(if: $isPublic)
        extractedAddress @skip(if: $isPublic) {
          streetAddress
          city
          state
          zipcode
        }
        geocodeData @skip(if: $isPublic) {
          errors {
            field
            message
          }
        }
      }
    }
  }

  ${exports.DOCUMENT_UPLOAD_DATA_FRAGMENT}
  ${exports.ALL_ATTACHED_GARAGE_CRAWLSPACE_INFO}
`;
(0, client_1.gql) `
  mutation UploadDocuments($data: CreateDocumentUploadsInput!) {
    createDocumentUploads(data: $data)
  }
`;
(0, client_1.gql) `
  mutation geocodeDocumentUpload(
    $documentUploadId: ID!
    $geocodeData: GeocodeDataInput!
  ) {
    geocodeDocumentUpload(
      documentUploadId: $documentUploadId
      geocodeData: $geocodeData
    )
  }
`;
//# sourceMappingURL=data:application/json;base64,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